import createClient, { type Middleware } from 'openapi-fetch';
import type { paths } from './api.types.gen';
import { env } from './env';

const requestIdMiddleware: Middleware = {
  onRequest({ request }) {
    if (!request.headers.has('x-request-id')) {
      request.headers.set('x-request-id', crypto.randomUUID());
    }
    return request;
  },
};

export const api = createClient<paths>({
  baseUrl: env.VITE_API_BASE_URL,
  credentials: 'include',
});

api.use(requestIdMiddleware);
